import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { nanoid } from "nanoid";

export function useSourceValidation() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isValidSource, setIsValidSource] = useState<boolean>(false);

  useEffect(() => {
    // Generate and store a unique lead_id if it doesn't exist yet
    if (!localStorage.getItem("lead_id")) {
      const uniqueLeadId = nanoid(10); // Create a short unique ID (10 characters)
      localStorage.setItem("lead_id", uniqueLeadId);
    }

    // Track the lead_id with Microsoft Clarity
    const leadId = localStorage.getItem("lead_id");
    if (leadId && typeof window !== "undefined" && window.clarity) {
      window.clarity("set", "lead_id", leadId);
    }

    // Parse the URL search params manually since we're using React Router instead of Next.js
    const searchParams = new URLSearchParams(location.search);
    const src = searchParams.get("src");

    if (src) {
      // Save src parameter to localStorage
      localStorage.setItem("src", src);

      // Create a new URL without the src parameter
      searchParams.delete("src");
      const newSearch = searchParams.toString();
      const newPath = location.pathname + (newSearch ? `?${newSearch}` : "");

      // Replace the current URL without the src parameter
      navigate(newPath, { replace: true });
    }

    // Check if src value in localStorage is "123456"
    const storedSrc = localStorage.getItem("src");
    setIsValidSource(storedSrc === "234453474fesd");
  }, [location, navigate]);

  return { isValidSource };
}
